// removed by extract-text-webpack-plugin
module.exports = {"row":"AccordionItem-row-f96b2b3e","col":"AccordionItem-col-2969fa9d","button":"AccordionItem-button-6ee88715","bannerAd":"AccordionItem-bannerAd-296128aa","rail":"AccordionItem-rail-532dd206","Accordion__Header":"AccordionItem-Accordion__Header-42c69d63","Accordion__Opener":"AccordionItem-Accordion__Opener-7ddf0836","Accordion__Container":"AccordionItem-Accordion__Container-14c16d10","icon":"AccordionItem-icon-dfe272b1","Accordion__Content":"AccordionItem-Accordion__Content-a602f952","Accordion__Button":"AccordionItem-Accordion__Button-f02bf5bc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FAQs/Accordion/AccordionItem/AccordionItem.scss
// module id = 853
// module chunks = 0